import { doc, DocumentReference } from 'firebase/firestore';
import isEmpty from 'lodash/isEmpty';
import { docData } from 'rxfire/firestore';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { IUser } from '../../types';
import { authenticatedUserProvider } from '../userProvider';

export interface ISessionWindowOption {
  label: string;
  value: 5 | 10 | 20;
}

export const sessionLimitOptions: ISessionWindowOption[] = [
  { label: '5 Session Window', value: 5 },
  { label: '10 Session Window', value: 10 },
  { label: '20 Session Window', value: 20 },
];

export interface IMetricHistorySetting {
  sessionLimits: ISessionWindowOption;
}

export const metricHistorySettingProvider =
  (): Observable<IMetricHistorySetting> => {
    return authenticatedUserProvider().pipe(
      switchMap((user: IUser): Observable<IMetricHistorySetting> => {
        return docData(
          doc(
            user.services.firestore,
            `userProfiles/${user.id}/settings/metricHistory`
          ) as DocumentReference<IMetricHistorySetting>
        ).pipe(
          map((setting: IMetricHistorySetting): IMetricHistorySetting => {
            if (!isEmpty(setting)) return setting;
            return {
              sessionLimits: {
                label: '5 Session Window',
                value: 5,
              },
            };
          })
        );
      })
    );
  };
